export class MainSectionClass {    
  
    constructor(data){
        this.id = data.id;
        this.name = data.name;
        this.description = data.description;
        this.is_active = data.is_active;
        this.mandatory = data.mandatory;
    }
}